module.exports = __webpack_public_path__ + "static/Cancer-e80bc50d40ef29fcb42058bb619d79d0.jpeg";